import React from "react";
import { ArrowUpRight, Cloud, ShieldCheck, GitBranch, Database, Cpu, Archive } from "lucide-react";

const ICONS = { "001": Cloud, "002": ShieldCheck, "003": GitBranch, "004": Database, "005": Cpu, "006": Archive };

export default function Capabilities({ data, SectionHeader }) {
  return (
    <section id="capabilities" className="relative py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-[1400px] mx-auto">
        <SectionHeader
          index="03"
          kicker="Capabilities"
          title="Six practices. One doctrine."
          description="Every practice ships against explicit acceptance criteria: security controls, availability targets, and cost envelopes. No abstract deliverables, no billable ambiguity."
        />
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-800/60 border border-slate-800/60 reveal">
          {data.map((c) => {
            const Icon = ICONS[c.id] || Cloud;
            return (
              <div
                key={c.id}
                className="group relative bg-slate-950 hover:bg-slate-900/70 p-8 transition-colors"
              >
                <div className="flex items-start justify-between mb-6">
                  <span className="font-mono text-[11px] tracking-[0.25em] text-slate-500">/ {c.id}</span>
                  <Icon className="text-cyan-400/80 group-hover:text-cyan-300 transition-colors" size={20} strokeWidth={1.4} />
                </div>
                <div className="eyebrow-muted mb-3">{c.tag}</div>
                <h3 className="text-xl font-semibold text-slate-50 tracking-tight mb-4 leading-snug">{c.title}</h3>
                <p className="text-sm text-slate-400 leading-relaxed mb-6">{c.desc}</p>
                <div className="flex flex-wrap gap-2 mb-6">
                  {c.meta.map((m) => (
                    <span key={m} className="font-mono text-[10px] tracking-widest uppercase text-slate-500 border border-slate-800 px-2 py-1">
                      {m}
                    </span>
                  ))}
                </div>
                <a href="#contact" className="inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-[0.2em] text-cyan-300 link-underline">
                  Engage <ArrowUpRight size={12} />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
